<template>
  <div class="footer-custom">
    <div class="container-fluid">
      <div class="row justify-content-center align-items-center mx-0 p-1">
        <div class="col text-start m-0 p-0">
          <div class="d-flex align-items-center gap-2">
            <div class="fs-6 powered-by-custom text-nowrap">Powered by:</div>
            <img class="logo-custom m-sm-1 py-2 py-md-0" src="/img/mexipass-logo-large.png">
          </div>
        </div>
        <div class="col text-center m-0 p-0 py-2">
          <a target="_blank" href="https://www.bbb.org/us/ca/pasadena/profile/insurance-companies/mexipass-international-insurance-services-llc-1216-13132294">
            <img class="bbb-custom" src="/img/bbb.png">
          </a>
        </div>
        <div class="col text-end m-0 p-0 py-2">
          <div class="copyright-custom">&copy; {{year}} MexiPass</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .footer-custom {
    position: fixed;
    bottom: 0;
    left: 0;
    border-top: 1px solid #ddf;
    background: #f9f9f9;
    min-height: 44px;
    width: 100%;
    line-height: 0px;
    padding: 0px;
    padding-left: 50px;
  }

  .powered-by-custom {
    margin-top: 14px;
  }

  .logo-custom {
    position: relative;
    width: 35vw;
    max-width: 122px;
  }

  .copyright-custom {
    white-space: nowrap;
    font-size: 12px;
    margin-top: 14px;
  }

  .bbb-custom {
    position: relative;
    width: 80px;
  }
</style>

<script>
  import lib from '@/lib'

  export default {
    props: [
      'DataLayer'
    ],

    mounted: function() {
      lib.ga({ 'event': 'optimize.AppFooter', 'locale': this.$i18n.locale })
    },

    computed: {
      year: function() {
        return new Date().getFullYear()
      }
    },
  }
</script>
